import React, { useState, useEffect, useRef } from 'react';
import './Filter.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RadioButtonGroup from '../RadioButtonGroup/RadioButtonGroup';
import CheckboxGroup from '../CheckboxGroup/CheckboxGroup';
import logComponent from '../../common/logComponent';

export default function Filter({ onChange, filters }) {
  const [visible, setVisible] = useState(false);
  const [mostRecentReset, setMostRecentReset] = useState(Date.now());
  const focusStartRef = useRef(null);
  const focusEndRef = useRef(null);
  const focusContainerRef = useRef(null);
  const focusStartBoundary = useRef(null);
  const focusEndBoundary = useRef(null);
  const anchorButtonRef = useRef(null);

  if (logComponent('Filter')) { console.debug('Filter rendered'); }

  const setFocusStartRef = (el) => {
    if (logComponent('Filter')) { console.debug('Filter setFocusStartRef'); }
    focusStartRef.current = el;
  }

  const setFocusEndRef = (el) => {
    if (logComponent('Filter')) { console.debug('Filter setFocusEndRef'); }
    focusEndRef.current = el;
  }

  const setFocusContainerRef = (el) => {
    if (logComponent('Filter')) { console.debug('Filter setFocusContainerRef'); }
    focusContainerRef.current = el;
  }

  const setFocusStartBoundary = (el) => {
    if (logComponent('Filter')) { console.debug('Filter setFocusStartBoundary'); }
    focusStartBoundary.current = el;
  }

  const setFocusEndBoundary = (el) => {
    if (logComponent('Filter')) { console.debug('Filter setFocusEndBoundary'); }
    focusEndBoundary.current = el;
  }

  const setAnchorButtonRef = (el) => {
    if (logComponent('Filter')) { console.debug('Filter setAnchorButtonRef'); }
    anchorButtonRef.current = el;
  }

  useEffect(() => {
    if (logComponent('Filter')) { console.debug('Filter useEffect [visible]'); }
    var focusable = focusContainerRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    setFocusStartRef(focusable[1]);
    setFocusEndRef(focusable[focusable.length - 2]);

    focusStartRef.current.focus();
  }, [visible]);

  const handleChange = (newValue) => {
    if (logComponent('Filter')) { console.debug('Filter handleChange'); }
    onChange(newValue);
  }

  const hide = (e) => {
    if (logComponent('Filter')) { console.debug('Filter hide'); }
    setVisible(false);
  }

  const toggleVisibility = () => {
    if (logComponent('Filter')) { console.debug('Filter toggleVisibility'); }
    setVisible(!visible);
  }

  const handleStartBoundaryFocus = (e) => {
    if (logComponent('Filter')) { console.debug('Filter handleStartBoundaryFocus'); }
    if (e.relatedTarget === focusEndBoundary) {
      focusStartRef.current.focus();
    } else {
      focusEndRef.current.focus();
    }
  }

  const handleEndBoundaryFocus = (e) => {
    if (logComponent('Filter')) { console.debug('Filter handleEndBoundaryFocus'); }
    if (e.relatedTarget === focusStartBoundary) {
      focusEndRef.current.focus();
    } else {
      focusStartRef.current.focus();
    }
  }

  const updateReset = () => {
    if (logComponent('Filter')) { console.debug('Filter updateReset'); }
    setMostRecentReset(Date.now());

    if (focusStartRef.current) focusStartRef.current.focus();
  }

  const handleKeyDown = (e) => {
    if (logComponent('Filter')) { console.debug('Filter handleKeyDown'); }
    if (e.key === 'Escape') {
      hide();
      if (anchorButtonRef.current) anchorButtonRef.current.focus();
    }
    
  }


  return (
    <div className="Filter-Group">
      <div className="Filter-Group__anchor">
        <button
          className="Filter-Group__anchor-button"
          ref={setAnchorButtonRef}
          onClick={toggleVisibility}>
          <FontAwesomeIcon
            icon="sliders-h"
            className="Filter-Group__anchor-icon" />
          <span className="Filter-Group__anchor-text">Filters</span>
          <FontAwesomeIcon
            icon="chevron-down"
            className="Filter-Group__chevron" />
        </button>
        <svg className={'Filter-Group__overlay-triangle' + (visible ? ' Filter-Group__overlay-triangle--visible' : '')} height="18px" width="36px" viewBox="0 0 36 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <path fill="#fdfdfd" strokeWidth="0" d="M 1.5,17 L 18,1 L 34.5,17 L1.5,17" />
          <path fill="transparent" strokeLinecap="round" d="M 2.5,15.5 L 18,1 L 33.5,15.5" />
        </svg>
      </div>
      <div
        className={'Filter-Group__overlay' + (visible ? ' Filter-Group__overlay--visible' : '')}
        onKeyDown={handleKeyDown}>
        <div
          className="Filter-Group__backdrop"
          onClick={hide}></div>
        <div
          className="Filter-Group__overlay-content"
          ref={setFocusContainerRef}>
          <span
            tabIndex="0"
            ref={setFocusStartBoundary}
            onFocus={handleStartBoundaryFocus}></span>
          <p className="Filter-Group__header">Filter by:</p>
          <div
            className="Filter-Group__filters">
            {
              filters.map(filter =>
                filter.hide ? null :
                  <div
                    className="Filter-Group__filter"
                    key={filter.name}>
                    <p className="Filter-Group__filter-title">{filter.title}</p>
                    {
                      filter.type === 'radio' &&
                      <RadioButtonGroup
                        onChange={handleChange}
                        name={filter.name}
                        initialSelection={filter.default}
                        options={filter.options}
                        reset={mostRecentReset} />
                    }
                    {
                      filter.type === 'checkbox' &&
                      <CheckboxGroup
                        onChange={handleChange}
                        name={filter.name}
                        options={filter.options}
                        reset={mostRecentReset}
                        initialSelections={ null}
                        horizontal={false}
                      />
                    }
                  </div>
              )
            }
          </div>
          <div className="Filter-Group__reset">
            <button
              className="Filter-Group__reset-button"
              onClick={updateReset}>reset filters</button>
          </div>
          <span
            tabIndex="0"
            ref={setFocusEndBoundary}
            onFocus={handleEndBoundaryFocus}></span>
        </div>
      </div>
    </div>
  );
}